var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGreenSmiley = function SvgGreenSmiley(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#3A853D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21652_14023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 22.5C18.4926 22.5 19.5 21.4926 19.5 20.25C19.5 19.0074 18.4926 18 17.25 18C16.0074 18 15 19.0074 15 20.25C15 21.4926 16.0074 22.5 17.25 22.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 22.5C31.9926 22.5 33 21.4926 33 20.25C33 19.0074 31.9926 18 30.75 18C29.5074 18 28.5 19.0074 28.5 20.25C28.5 21.4926 29.5074 22.5 30.75 22.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 28.5C29.9437 31.1906 27.3319 33 24 33C20.6681 33 18.0563 31.1906 16.5 28.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21652_14023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGreenSmiley);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iMjQiIGZpbGw9IiMzQTg1M0QiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxNjUyXzE0MDIzKSI+CjxwYXRoIGQ9Ik0xNy4yNSAyMi41QzE4LjQ5MjYgMjIuNSAxOS41IDIxLjQ5MjYgMTkuNSAyMC4yNUMxOS41IDE5LjAwNzQgMTguNDkyNiAxOCAxNy4yNSAxOEMxNi4wMDc0IDE4IDE1IDE5LjAwNzQgMTUgMjAuMjVDMTUgMjEuNDkyNiAxNi4wMDc0IDIyLjUgMTcuMjUgMjIuNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMC43NSAyMi41QzMxLjk5MjYgMjIuNSAzMyAyMS40OTI2IDMzIDIwLjI1QzMzIDE5LjAwNzQgMzEuOTkyNiAxOCAzMC43NSAxOEMyOS41MDc0IDE4IDI4LjUgMTkuMDA3NCAyOC41IDIwLjI1QzI4LjUgMjEuNDkyNiAyOS41MDc0IDIyLjUgMzAuNzUgMjIuNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMS41IDI4LjVDMjkuOTQzNyAzMS4xOTA2IDI3LjMzMTkgMzMgMjQgMzNDMjAuNjY4MSAzMyAxOC4wNTYzIDMxLjE5MDYgMTYuNSAyOC41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIxNjUyXzE0MDIzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";